(function ($) {
  DJ.addBehavior('changeSchool', '#change-school-accordion-group', {
    attach: function () {
      const accordion = $(this);
      const accordionTrigger = $('.change-school-accordion__trigger', accordion);
      const accordionPanel = $('.change-school-accordion__panel', accordion);
      const mq = window.matchMedia('(min-width: 768px)');
      const scrollWrapper = $('.change-school-accordion__scroll-wrapper', accordion);

      const changeSchool = (query) => {
        if (query.matches) {
          accordionPanel.attr('hidden', '');
          accordionTrigger.first().attr('aria-expanded', 'true');
          accordionPanel.first().removeAttr('hidden');
        }
      };

      changeSchool(mq);
      mq.addListener(changeSchool);

      accordionTrigger.click((e) => {
        e.preventDefault();
        e.stopPropagation();

        const { target } = e;
        const isExpanded = target.getAttribute('aria-expanded') === 'true';
        const active = accordion[0].querySelector('[aria-expanded="true"]');

        if (active && active !== target) {
          active.setAttribute('aria-expanded', 'false');
          document.getElementById(active.getAttribute('aria-controls')).setAttribute('hidden', '');
          jcf.destroy(scrollWrapper);
          jcf.replace(scrollWrapper, 'Scrollable');
        }
        if (!isExpanded) {
          target.setAttribute('aria-expanded', 'true');
          document.getElementById(target.getAttribute('aria-controls')).removeAttribute('hidden');
          jcf.destroy(scrollWrapper);
          jcf.replace(scrollWrapper, 'Scrollable');
        }
      });

      accordionTrigger.keydown((e) => {
        const code = e.keyCode || e.which;

        if (code === 13 || code === 32) {
          e.preventDefault();
          e.stopPropagation();
          $(e.target).click();
        }
      });

      jcf.replace(scrollWrapper, 'Scrollable');
    }
  });
})(jQuery);
